export { default } from './CheckedOutStatusIcon';



// WEBPACK FOOTER //
// ./app/components/borrowing/checkouts/CheckedOutStatusIcon/index.js